import type { HelpFile } from '../../types/help'
import { NotificationDetailTestIds } from '../../../testids/NotificationDetailTestIds'

export const notificationDetailHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [NotificationDetailTestIds.notificationDetailPage]:
      'Full content and context for one notification — event, timestamp, severity, and linked entity.',
    [NotificationDetailTestIds.cardNotificationDetail]:
      'Notification metadata: subject, timestamp, severity, and the delivery channel.',
    [NotificationDetailTestIds.notificationMessage]: null,
    [NotificationDetailTestIds.cardTitleGoToReference]:
      'Direct link to the entity referenced by this notification.',
    [NotificationDetailTestIds.linkReferencedEntity]: null,
  },
}
